module.exports = __webpack_public_path__ + "img/Hallux-valgus.9b4d2391.jpg";